export const LANDING = '/';
export const SIGN_UP = '/signup';
export const SIGN_IN = '/signin';
export const EMAIL_VERIFICATION = '/verify-email';
export const DASHBOARD = '/dashboard';
export const HOME = '/home';
export const ACCOUNT = '/account';
export const PASSWORD_FORGET = '/pw-forget';
export const PASSWORD_CHANGE = '/password-change';
export const SETTINGS = '/settings';
export const PROFILE = '/profile';
export const ADMIN = '/admin';
export const ADMIN_DETAILS = '/admin/:id';

// Franchise Routes
export const FRANCHISE_REGISTRATION_DASHBOARD = '/franchise-registration-dashboard';
export const FRANCHISE_ONBOARDING = '/franchise-onboarding/:franchiseId';
export const FRANCHISE_DASHBOARD = '/franchise-dashboard';
export const FRANCHISE_BRAND_KIT_VIEW = '/franchise-brand-kit-view';
export const FRANCHISE_TEAM = '/franchise-team';
export const FRANCHISE_LEADS = '/franchise-leads';
export const FRANCHISE_BRANDING = '/franchise-branding';
export const FRANCHISE_SETTINGS = '/franchise-settings';

// Platform Admin Routes (jeethbuildcon only)
export const ADMIN_SIGNIN = '/jeethbuildcon/signin';
export const ADMIN_PANEL = '/jeethbuildcon/dashboard';
export const ADMIN_BUILDER = '/jeethbuildcon/builder';
export const ADMIN_FRANCHISE_DETAIL = '/jeethbuildcon/dashboard/:franchiseId';
export const ADMIN_CUSTOMER_DETAIL = '/jeethbuildcon/customer/:agreementId';
export const FRANCHISE_AGREEMENT = '/franchise-agreement/:agreementId';
export const PAYMENT_SUCCESS = '/payment-success/:agreementId';
export const PAYMENT_FAILURE = '/payment-failure/:agreementId';
export const TERMS = '/terms';
export const PRIVACY = '/privacy';
export const CANCELLATION_REFUND = '/cancellation-refund';
